import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_service = async (service) => {
  try {
    let data = new FormData();
    data.append("image", service?.image[0]);
    data.append("name", service?.name);
    data.append("code", service?.code);
    data.append("category", service?.category);
    data.append("duration", service?.duration);
    data.append("description", service?.description);
    data.append("cost_price", service?.cost_price);
    data.append("sale_price", service?.sale_price);
    data.append("tax", service?.tax);
    data.append("status", service?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-service`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_service = async (service) => {
  try {
    let data = new FormData();
    data.append("id", service?.id);
    data.append("image", service?.image[0]);
    data.append("name", service?.name);
    data.append("code", service?.code);
    data.append("category", service?.category);
    data.append("duration", service?.duration);
    data.append("description", service?.description);
    data.append("cost_price", service?.cost_price);
    data.append("sale_price", service?.sale_price);
    data.append("tax", service?.tax);
    data.append("status", service?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-service`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_service = async (service) => {
  try {
    const data = {
      id: service?.id ? service?.id : service,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-service`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_services = async (service) => {
  try {
    const data = {
      search: service?.search,
      sort: service?.sort,
      category: service?.category,
      status: service?.status,
      page: service?.page,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-all-services`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_service_name = async (service) => {
  try {
    const data = {
      name: service?.name,
      branch: service?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-service-name`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_service,
  update_service,
  get_service,
  get_all_services,
  get_service_name,
};